import {createAsyncThunk} from '@reduxjs/toolkit';
import analyticsApi from 'common/src/modules/analytics/analytics.api';
import {CAMPAIGN_METRICS} from '../campaignsLibrary.consts';
import {setCampaignMetrics} from '../campaignsLibrary.slice';
import getUrlQueryParamValue from 'common/src/utils/urlUtils/getUrlQueryParamValue/getUrlQueryParamValue';
import {CampaignSearchParamKey} from '../campaignsLibrary.enums';
import convertDatesFromUrlFilters from 'common/src/utils/urlFiltersUtils/convertDatesFromUrlFilters';
import _find from 'lodash/find';
import {TimezoneObject} from 'common/src/modules/timezones/timezones.types';
import timezonesService from 'common/src/modules/timezones/timezones.service';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const fetchCampaignsAnalytics = createAsyncThunk(
  `${BreadcrumbName.CampaignsLibrary}/fetchCampaignsAnalytics`,
  async (_, {dispatch}) => {
    const date = getUrlQueryParamValue<string>(CampaignSearchParamKey.Date);
    const timezone = getUrlQueryParamValue<string>(CampaignSearchParamKey.Timezone);

    const info = await timezonesService.getDateTimeInfo();

    const {startDate, endDate} = convertDatesFromUrlFilters(date);
    const selectedTimezone = _find(
      info.timezoneMapper,
      ({abbr}) => abbr === timezone,
    ) as TimezoneObject;

    const metrics = await analyticsApi.getCampaignsMetrics({
      campaignMetrics: CAMPAIGN_METRICS,
      dateRange: {
        startDate: startDate,
        endDate: endDate.endOf('day'),
      },
      selectedTimezone,
    });

    dispatch(setCampaignMetrics(metrics));
  },
);

export default fetchCampaignsAnalytics;
